import React from 'react';
import { IMemberAvatarAndName } from './interfaces';
import { Badge, Box, Stack, Tooltip, Typography } from '@mui/material';
import { MemberAvatar } from '@components/MemberAvatar';

export const MemberAvatarAndName: React.FC<IMemberAvatarAndName> = ({
  slug,
  name,
  size,
  children,
  nameBadge,
}): JSX.Element => {
  const nameNode = (
    <Typography variant="body2">{name}</Typography>
  );

  const nameWithBadge = nameBadge ? (
    <Tooltip title={nameBadge.tooltip ?? ''}>
      <Badge
        variant="dot"
        color="primary"
        overlap="rectangular"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          '& .MuiBadge-badge': {
            right: -6,
            top: 4,
          },
        }}
      >
        {nameNode}
      </Badge>
    </Tooltip>
  ) : (
    nameNode
  );

  return (
    <Stack alignItems="center" height="100%" gap="10px" direction="row">
      <MemberAvatar
        slug={slug}
        name={name}
        sx={{
          width: size || '30px',
          height: size || '30px',
          borderWidth: '1px',
        }}
      />
      <Box>
        {nameWithBadge}
        {children}
      </Box>
    </Stack>
  );
};
